import { createContext } from '@/utils';
import type { useDeleteEvent } from '../../hooks/useDeleteEvent';
import type { useRemoveEvent } from '../../hooks/useRemoveEvent';
import type { useUpdateEvent } from '../../hooks/useUpdateEvent';
import type { CollectionBase, DecoratedEvent } from '../../types';

type CollectionContextType = {
  base: CollectionBase | null;
  setBase: (base: CollectionBase | null) => void;
  events: DecoratedEvent[];
  updateMutation: ReturnType<typeof useUpdateEvent>;
  deleteMutation: ReturnType<typeof useDeleteEvent>;
  removeMutation: ReturnType<typeof useRemoveEvent>;
  revalidate: () => void;
};

export const CollectionContext = createContext<CollectionContextType>(
  {} as CollectionContextType,
  'CollectionContext'
);
